var map = {
	"./App.vue": "./js/App.vue",
	"./views/404.vue": "./js/views/404.vue",
	"./views/Admin.vue": "./js/views/Admin.vue",
	"./views/Client.vue": "./js/views/Client.vue",
	"./views/Dashboard.vue": "./js/views/Dashboard.vue",
	"./views/Login.vue": "./js/views/Login.vue",
	"./views/Report.vue": "./js/views/Report.vue"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./js sync recursive .+\\.vue$";